// extracted by mini-css-extract-plugin
export default {"modalBodyContainer":"rename-modal_modalBodyContainer__+08+Y","inputContainer":"rename-modal_inputContainer__hB1Ej"};